import { useMediaQuery } from "@/zapi-frontend/shared/hooks/useMediaQuery";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { ChatTestIsland } from "@/zapi-frontend/widgets/ChatTestIsland";
import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { AppButton, ClickAwayListener, Typography } from "@libs/zapi-ui/custom";
import { XIcon } from "@phosphor-icons/react";
import { SparkleIcon } from "@phosphor-icons/react/dist/ssr";
import { useState } from "react";

type TProps = {
  chapterName?: string;
};

export function WorkspaceRoomsIsland({ chapterName }: TProps) {
  const isTablet = useMediaQuery("(max-width: 984px)");

  const [isOpen, setIsOpen] = useState(false);

  const openHandler = () => setIsOpen(true);
  const closeHandler = () => setIsOpen(false);

  return (
    <>
      <AppButton
        appearance="text"
        size="icon"
        onClick={openHandler}
        className="fixed bottom-6 right-6 bg-innoveraZinc-900 [&_svg>path]:fill-white w-[40px] h-[40px] rounded-full hover:bg-innoveraZinc-800 transition-colors duration-300"
      >
        <InnoveraIcon className="w-6 h-6" />
      </AppButton>
      <ClickAwayListener onClickAway={closeHandler}>
        <div
          data-testid="workspace-rooms-root"
          className={cn(
            "fixed top-0 border-l border-innoveraZinc-200 h-[100svh] tablet:h-full w-full mobile:max-w-[341px] bg-white", // it might need to be returned tablet:max-w-[clamp(420px,18vw,720px)]
            "hd:static hd:border-none hd:bottom-auto hd:top-0 transition-all duration-300",
            isOpen ? "right-0" : "right-[-100%]"
          )}
        >
          <div data-testid="workspace-rooms-header" className="w-full h-14 flex items-center justify-between px-4">
            <div className="w-full flex h-[56px] mx-3 items-center">
              <Typography variant="label2" color="zinc500" className="inline-flex items-center gap-2">
                <SparkleIcon /> Chat
              </Typography>

              {isTablet && (
                <AppButton appearance="text" size="icon" onClick={closeHandler} className="ml-auto">
                  <XIcon />
                </AppButton>
              )}
            </div>
          </div>

          <div data-testid="workspace-rooms-content" className="h-[calc(100svh-56px)] hd:h-[calc(100vh-127px)]">
            <div className="h-full">
              <ChatTestIsland chapterName={chapterName} />
            </div>
          </div>
        </div>
      </ClickAwayListener>
    </>
  );
}
